<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <div class="card-body">
      <div class="col-lg-6">
        <selectlist
          name="title"
          v-model="form.title_id"
          :options="titles"
          label="Title"
          helper="Please select the title for the third party"
          placeholder="Please Select"
        ></selectlist>

        <inputbox
          v-model="form.first_name"
          name="first_name"
          label="First Name"
          helper="Please enter the first name for the third party"
        ></inputbox>

        <inputbox
          v-model="form.last_name"
          name="last_name"
          label="Last Name"
          helper="Please enter the last name for the third party"
        ></inputbox>

        <selectlist
          name="gender"
          v-model="form.gender_id"
          :options="genders"
          label="Gender"
          helper="Please select the gender for the third party"
          placeholder="Please Select"
        ></selectlist>

        <fieldset>
          <legend>
            Address Details
          </legend>
          <toggleswitch
            :labels="true"
            name="address_details_known"
            v-model="form.address_details_known"
            helper="If the client knows the third party's address, please toggle this switch."
            label="Does the client know the third party's address?"
          ></toggleswitch>

          <div v-if="form.address_details_known">
            <address-lookup
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>
          </div>
        </fieldset>
      </div>
      <div class="col-lg-6">
        <toggleswitch
          :labels="true"
          name="contact_details_known"
          v-model="form.contact_details_known"
          helper="If the client knows the contact details for the third party, please toggle this switch."
          label="Does the client know the third party's contact details?"
        ></toggleswitch>

        <div v-if="form.contact_details_known">
          <inputbox
            name="email_address"
            label="Email Address"
            type="email"
            helper="Please enter the email address for the third party"
            v-model="form.email_address"
          ></inputbox>

          <inputbox
            name="telephone"
            label="Telephone"
            v-model="form.telephone"
            helper="Please enter a contact number for the third party"
          ></inputbox>
        </div>

        <fieldset>
          <legend>
            Insurance Details
          </legend>
          <selectlist
            name="insurer"
            :options="insurers"
            v-model="form.insurer_id"
            label="Insurer"
            helper="Please select the company the third party uses to insure their vehicle"
            placeholder="Please Select"
            label-name="name"
          ></selectlist>
          <inputbox
            name="gta"
            label="Is GTA?"
            :readonly="true"
            v-model="isGTA"
          ></inputbox>
          <inputbox
            name="policy_number"
            label="Policy Number"
            v-model="form.policy_number"
            helper="Please enter the policy number for the third party's insurance policy"
          ></inputbox>
          <inputbox
            name="claim_number"
            label="Claim Number"
            v-model="form.claim_number"
            helper="If the incident has been reported to the third party's insurer, please enter the claim number here"
          ></inputbox>
        </fieldset>
      </div>
    </div>
    <div class="card-footer text-right">
      <button
        v-if="thirdParty"
        class="btn btn-danger btn-raised float-left"
        name="delete"
        v-on:click.prevent="deleteThirdParty"
      >
        <i class="icon icon-delete"></i> Delete
      </button>
      <button
        class="btn btn-primary btn-raised"
        name="cancel"
        v-on:click.prevent="cancel"
      >
        <i class="icon icon-cancel"></i> Back
      </button>
      <button
        class="btn btn-primary btn-raised"
        name="save"
        v-on:click.prevent="saveDetails"
      >
        <i class="icon icon-save"></i> Save
      </button>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    thirdParty: {
      type: String
    }
  },

  data() {
    return {
      form: new window.Form({
        title_id: null,
        first_name: null,
        last_name: null,
        gender_id: null,
        contact_details_known: false,
        email_address: null,
        telephone: null,
        address_details_known: false,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        insurer_id: null,
        policy_number: null,
        claim_number: null
      }),
      identifier: null,
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    titles() {
      return this.$store.getters['Titles/all'];
    },
    genders() {
      return this.$store.getters['Genders/all'];
    },
    insurers() {
      return this.$store.getters['Insurers/all'];
    },
    isGTA() {
      if (this.form.insurer_id) {
        let insurer = this.insurers.find(insurer => {
          return insurer.id === parseInt(this.form.insurer_id);
        });

        if (insurer && insurer.gta) {
          return 'Yes';
        }

        return 'No';
      }

      return 'Please Select an Insurer';
    },

    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      if (this.thirdParty) {
        window.Ajax.get(
          `/incidents/${this.incident}/third-parties/${this.thirdParty}`
        )
          .then(response => {
            if (response.data) {
              let data = response.data;

              this.form.title_id = data.title_id;
              this.form.first_name = data.first_name;
              this.form.last_name = data.last_name;
              this.form.gender_id = data.gender_id;
              this.form.contact_details_known = data.contact_details_known;
              this.form.email_address = data.email_address;
              this.form.telephone = data.telephone;
              this.form.address_details_known = data.address_details_known;
              this.form.address_line_one = data.address_line_one;
              this.form.address_line_two = data.address_line_two;
              this.form.city = data.city;
              this.form.postcode = data.postcode;
              this.form.insurer_id = data.insurer_id;
              this.form.policy_number = data.policy_number;
              this.form.claim_number = data.claim_number;
            }
          })
          .catch(error => {});
      }
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    deleteThirdParty() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              `/incidents/${this.incident}/third-parties/${this.thirdParty}`
            )
              .then(response => {
                this.$emit('deleted', this.thirdParty);
                this.indicator = false;
                this.$router.back();
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the third party.'
                );
              });
          }
        })
        .catch(error => {});
    },

    saveDetails() {
      !this.thirdParty ? this.submit() : this.updateThirdParty();
    },

    updateThirdParty() {
      this.form
        .put(`/incidents/${this.incident}/third-parties/${this.thirdParty}`)
        .then(response => {
          this.$emit('updated', response);
          window.toastify.success(
            'Success!',
            'The third party was updated successfully!'
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the third party'
          );
        });
    },

    submit() {
      this.form
        .post(`/incidents/${this.incident}/third-parties`)
        .then(response => {
          this.$emit('created', response.identifier);
          window.toastify.success(
            'Success!',
            'The third party was created successfully!'
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an error creating the third party.'
          );
        });
    },

    cancel() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
          this.$router.back();
        })
        .catch(error => {});
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
